// extracted by mini-css-extract-plugin
module.exports = {"durationInformation":"DurationInformation_durationInformation__3zE0M","title":"DurationInformation_title__uwNZz"};